import { jsx as _jsx } from "react/jsx-runtime";
import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';
export const Panel = React.forwardRef(function Panel({ className, children }, ref) {
    return (_jsx("div", { ref: ref, className: clsx(className, 'flex flex-col'), children: children }));
});
export const PanelHeader = React.forwardRef(function PanelHeader({ className, children }, ref) {
    return (_jsx("div", { ref: ref, className: clsx(className, 'justify-leading flex shrink-0 items-center space-x-2 py-1', 'border-b border-zinc-950/10 dark:border-white/10', 'bg-zinc-50 dark:bg-zinc-900'), children: children }));
});
const backgrounds = {
    primary: 'bg-white dark:bg-zinc-900',
    secondary: 'bg-zinc-50 dark:bg-zinc-900'
};
export const PanelBody = React.forwardRef(function PanelBody({ background, className, children }, ref) {
    return (_jsx("div", { ref: ref, className: clsx(className, backgrounds[background !== null && background !== void 0 ? background : 'primary'], 'h-full'), children: children }));
});
export const PanelTab = React.forwardRef(function PanelTab({ children }, ref) {
    return (_jsx(Tab, { ref: ref, children: ({ selected }) => (_jsx("span", { className: clsx(selected
                ? 'font-semibold text-zinc-600 dark:text-white/60'
                : 'text-zinc-500 hover:text-zinc-700 dark:text-white/50 dark:hover:text-white/70', 'flex items-center whitespace-nowrap px-2 py-1 text-xs font-medium'), children: children })) }));
});
